module.exports = __webpack_public_path__ + "assets/img/37_1003_big.c96eded2.jpg";